import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export class PvToolParameter extends React.Component<{}, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_PV_PARAMETER}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_PV_PARAMETER)}
                />
            </div>
        );
    }
}
